import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClientNameService {
  constructor() { }

  /**
   * Простой метод форматирования имени клиента
   * @param client Объект с полями firstName и lastName
   * @param settings Массив настроек клуба (уже загруженные)
   * @returns Отформатированное имя клиента
   */
  public formatClientName(
    client: { firstName?: string; lastName?: string },
    settings: any[]
  ): string {
    if (!client) {
      return '';
    }

    const firstName = client.firstName || '';
    const lastName = client.lastName || '';

    // Проверяем настройку порядка имени/фамилии
    const isSwapOrder = settings?.find(s => s.alias === 'IsSwapNameOrder')?.value === 'true';

    if (isSwapOrder) {
      return `${lastName} ${firstName}`.trim();
    } else {
      return `${firstName} ${lastName}`.trim();
    }
  }
}


